<template>
  <div class="et-property-panel">
    <header class="et-property-panel__header">
      <EtTab :tabs="tabs" v-model="tab" />
    </header>

    <div class="et-property-panel__body">
      <KeepAlive>
        <EtProperty v-if="tab === 1" />
        <EtLayer v-else />
      </KeepAlive>
    </div>

    <footer class="et-property-panel__footer">
      <button type="button" class="et-btn et-btn--primary" @click="onSave">保存</button>
      <div class="et-property-panel__footer-row">
        <button type="button" class="et-btn et-btn--secondary" @click="onImport">导入</button>
        <button type="button" class="et-btn et-btn--secondary" @click="onExport">导出</button>
      </div>
    </footer>
  </div>
</template>

<script setup>
import { ref, inject } from 'vue'
// import { modifyTopo } from "@/api/paramSetting/topo"
import { ElMessage } from 'element-plus'

import EtTab from './components/tab.vue'
import EtProperty from './property.vue'
import EtLayer from './layer.vue'

const topology = inject('topology')
const tab = ref(1)

const tabs = [
  {
    label: '属性',
    value: 1,
  },
  {
    label: '图层',
    value: 2,
  }
]

// 保存json到服务器
function onSave() {
  const json = topology.toJSON()

  // modifyTopo(JSON.stringify(json)).then(r => {
  //   if (r.code == 200) {
  //     ElMessage.success(r.msg)
  //     // 稍作延迟以便让提示显示，然后刷新页面
  //     setTimeout(() => {
  //       window.location.reload()
  //     }, 600)
  //   }
  // })
}


// 导入json
function onImport() {
  const input = document.createElement('input')
  input.type = 'file'
  input.accept = '.json'
  input.onchange = e => {
    const file = e.target.files[0]
    if (file) {
      const reader = new FileReader()
      reader.onload = e => {
        const json = JSON.parse(e.target.result)
        topology.clear()
        topology.fromJSON(json)
        ElMessage.success('导入成功')
        input.remove()
      }
      reader.readAsText(file)
    }
  }
  input.click()
}

// 下载json文件
function onExport() {
  const json = topology.toJSON()
  const a = document.createElement('a')
  a.href = URL.createObjectURL(new Blob([JSON.stringify(json, null, 2)]))
  a.download = `topology_${Date.now()}.json`
  a.click()
  URL.revokeObjectURL(a.href)
  a.remove()
  ElMessage.success('导出成功')
}

</script>

<style scoped>
.et-property-panel {
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
}

.et-property-panel__header {
  flex-shrink: 0;
  padding: 6px 6px 0;
}

.et-property-panel__body {
  flex: 1;
  min-height: 0;
  overflow-x: hidden;
  overflow-y: auto;
  padding: 6px;
  scrollbar-width: thin;
  scrollbar-color: rgba(255, 255, 255, 0.22) transparent;
}

.et-property-panel__body::-webkit-scrollbar {
  width: 4px;
}

.et-property-panel__body::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.22);
  border-radius: 2px;
}

.et-property-panel__footer {
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 8px 6px;
  border-top: 1px solid rgba(255, 255, 255, 0.08);
  background: rgba(0, 0, 0, 0.18);
}

.et-property-panel__footer-row {
  display: flex;
  gap: 6px;
}

.et-property-panel__footer .et-btn {
  flex: 1;
  min-width: 0;
  height: 28px;
  padding: 0 8px;
  border: none;
  border-radius: 4px;
  font-size: 12px;
  line-height: 1;
  cursor: pointer;
  transition: background-color 0.2s ease, opacity 0.2s ease;
}

.et-property-panel__footer .et-btn:focus-visible {
  outline: 2px solid #178ffc;
  outline-offset: 1px;
}

.et-property-panel__footer .et-btn--primary {
  background: #178ffc;
  color: #fff;
}

.et-property-panel__footer .et-btn--primary:hover {
  background: #117bdf;
}

.et-property-panel__footer .et-btn--secondary {
  background: #474747;
  color: rgba(255, 255, 255, 0.92);
}

.et-property-panel__footer .et-btn--secondary:hover {
  background: #636363;
}

@media (prefers-reduced-motion: reduce) {
  .et-property-panel__footer .et-btn {
    transition: none;
  }
}

/* 属性表单项：与面板内边距对齐 */
.et-property-panel__body :deep(.et-property__item) {
  padding: 8px 4px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.05);
}

.et-property-panel__body :deep(.et-property__item:last-child) {
  border-bottom: none;
}



.et-property-panel__body :deep(.et-property__value) {
  margin-top: 6px;
}

.et-property-panel__body :deep(input.et-property__value) {
  width: 100%;
  box-sizing: border-box;
  border-radius: 4px;
  transition: border-color 0.2s ease, color 0.2s ease;
}

.et-property-panel__body :deep(input.et-property__value::placeholder) {
  color: rgba(255, 255, 255, 0.28);
}
</style>
